import { SET_SYNCING_IN_LIVE_MODE } from '../../types';

const setSyncingInLiveMode = (status) => (dispatch) => {
  dispatch({ type: SET_SYNCING_IN_LIVE_MODE, status });
};

export { setSyncingInLiveMode };
